// Rudragarh master menu — transcribed from the printed menu (Sept 2026).
// Item tuple: [name, price, description?]. Price is a number or a range string.

export const THALI = {
  name: 'Rudragarh Shahi Thali',
  price: 599,
  desc: 'A regal spread featuring Chhaass, Moong Dal Pakode, Shahi Paneer, Dal, Bati, Churma, Kadhi, Gatte ki Sabzi, Mix Veg, Kheer (Sewaiyan)/Malpua, Phulka (2), Bajre ki Roti, Papad Churi/Papad, Mirchi ka Kutta.',
};

export const MENU_NOTES = [
  'Please inform your server of any food allergies before ordering.',
  'Please inform your server before placing your order if you prefer any adjustments to the level of salt or spices in your meal.',
];

export const MENU = [
  {
    title: 'Beverages',
    items: [
      ['Tea', 40],
      ['Coffee (Milk / Black)', 60],
      ['Honey Ginger Tea', 50],
      ['Blue Tea', 50],
      ['Black Tea', 60],
      ['Green Tea', 60],
      ['Milk (Plain)', 80],
      ['Bournvita', 80],
      ['Lemonade', 80],
      ['Lassi', 140],
      ['Chaach', 140],
      ['Cold Coffee', 150],
      ['Strawberry Shake', 140],
      ['Kitkat Shake', 140],
      ['Mango Shake', 140],
      ['Banana Shake', 180],
      ['Oreo Shake', 180],
      ['Nutella Shake', 180],
      ['Biscoff Shake', 180],
    ],
  },
  {
    title: 'Breakfast & Regional Classics',
    items: [
      ['Paratha (Aloo / Gobi / Mooli / Paneer / Besan)', 160, 'Whole wheat flatbread stuffed with flavorful spiced fillings, cooked golden on a griddle. Served with curd and achaar.'],
      ['Poori Sabzi', 150, 'Fluffy deep-fried golden bread served with traditional spiced potato curry.'],
      ['Chole Bhature', 200, 'Spicy tangy chickpea curry paired with large, fluffy leavened fried bread.'],
      ['Pav Bhaji', 200, 'Mashed vegetable curry cooked with special spices, served with butter-toasted soft bread rolls.'],
      ['Chilla (Moong Dal / Besan)', 150, 'Savory lentil or gram flour pancakes seasoned with aromatic herbs and spices.'],
      ['Bread Pakoda', 100, 'Spiced potato stuffed bread slices coated in chickpea batter and deep-fried to crisp perfection.'],
      ['Idli', 150, 'Soft, fluffy steamed rice and lentil cakes served with sambhar and coconut chutney.'],
      ['Medu Vada', 150, 'Golden lentil doughnuts with a soft, fluffy interior.'],
      ['Uttapam', 120, 'Thick South Indian pancake topped with finely chopped garden-fresh vegetables.'],
      ['Appam', 180, 'Lacy bowl-shaped fermented rice pancake with a soft center and crispy edges.'],
      ['Upma', 180, 'Savory semolina porridge tempered with mustard seeds, curry leaves, and vegetables.'],
      ['Dosa', 180, 'Thin, golden, crispy fermented crepe made from rice and lentil batter, served with sambhar and chutneys.'],
      ['Poha', 100, 'Light and fluffy flattened rice tempered with turmeric, mustard seeds, green chilies, and peanuts.'],
      ['Khaman', 100, 'Spongy, savory steamed gram flour cake garnished with mustard seeds and fresh coriander.'],
      ['Bun Maska', 80, 'Soft bakery bun generously slathered with rich, creamy butter.'],
      ['Chilli Cheese Bun', 150, 'Toasted bun loaded with melting cheese, green chilies, and fiery seasonings.'],
      ['Veg Cutlet', 200, 'Crispy breaded patties stuffed with spiced mashed vegetables and potatoes.'],
      ['Plain Maggi', 80, 'Classic comforting instant noodles cooked with signature tastemaker spices.'],
      ['Veg Maggi', 100, 'Instant noodles tossed with fresh garden vegetables.'],
      ['Cheese Maggi', 120, 'Rich and creamy instant noodles topped with a generous layer of melting cheese.'],
      ['Cornflake', 150, 'Crispy golden cereal flakes served with chilled milk and a touch of sweetness.'],
      ['Bread Fills (Jam / Butter / Peanut Spread)', 150, 'Freshly sliced bread spread with choice of sweet jam, creamy butter, or peanut spread.'],
      ['Sandwiches of Choice (Aloo / Veg / Cheese)', 200, 'Grilled sandwiches stuffed with seasoned potatoes, vegetables, or gooey cheese.'],
    ],
  },
  {
    title: 'Soups',
    items: [
      ['Tomato Basil Soup', 150, 'Rich and velvety soup prepared from vine-ripened tomatoes and fresh fragrant basil.'],
      ['Manchow Soup', 150, 'Dark, spicy, and tangy Indo-Chinese soup topped with crispy fried noodles.'],
      ['Sweet Corn Soup', 160, 'Comforting golden soup featuring tender sweet corn kernels in a flavorful broth.'],
      ['Hot N Sour Soup', 160, 'Vibrant and spicy soup balanced with zesty vinegar and savory notes.'],
      ['Mushroom Soup', 150, 'Smooth, earthy, and aromatic broth infused with fresh sautéed mushrooms.'],
    ],
  },
  {
    title: 'Salads',
    items: [
      ['Fruit Salad', 220, 'A refreshing medley of seasonal tropical fruits tossed to perfection.'],
      ['Kachumber Salad', 150, 'Finely diced cucumbers, tomatoes, and onions tossed with fresh lemon juice and herbs.'],
      ['Fresh Green Salad', 100, 'Crisp, farm-fresh green vegetable slices served with lemon and green chili.'],
      ['Beetroot & Carrot Salad', 100, 'Freshly sliced beetroot and carrot salad garnished with lemon, mint, and chat masala.'],
    ],
  },
  {
    title: 'Raitas',
    items: [
      ['Plain Curd', 80],
      ['Boondi Raita', 120],
      ['Veg Raita', 120],
      ['Fried Raita', 130],
      ['Louki Raita', 130],
      ['Beetroot Raita', 150],
      ['Pineapple Raita', 150],
      ['Cucumber Raita', 150],
    ],
  },
  {
    title: 'Papads & Khichiya',
    items: [
      ['Roasted Papad', 60],
      ['Fried Papad', 80],
      ['Masala Papad (Fried / Roasted)', 80],
      ['Roasted Khichiya', 60],
      ['Fried Khichiya', 80],
      ['Masala Khichiya (Fried / Roasted)', 100],
      ['Rice Papad', 80],
    ],
  },
  {
    title: 'Short Bites & Starters',
    items: [
      ['Classic Nachos', 180, 'Crisp corn tortilla chips topped with melted cheese and a tangy salsa, offering a crunchy and savory bite.'],
      ['Loaded Nachos', 200, 'Tortilla chips heavily piled with melted cheese, beans, jalapeños, and sauces for a rich, spicy, and indulgent treat.'],
      ['Cheese Balls', 250, 'Crispy fried spheres packed with gooey, melted cheese, delivering a warm, savory, and comforting crunch.'],
      ['Salted Fries', 150, 'Golden, crispy potato french fries seasoned simply with table salt for a classic, savory, and comforting snack.'],
      ['Peri Peri Fries', 200, 'Crispy potato fries tossed in a fiery, tangy spice mix for a hot and zesty kick.'],
      ['Crunchy Crispy Corn', 250, 'Sweet corn kernels coated in a seasoned batter and deep-fried until crunchy, offering a sweet, spicy, and crispy bite.'],
      ['Bhel', 220, 'A refreshing mix of puffed rice, sev, chopped veggies, and tangy chutneys for a crunchy, sweet, and spicy street-food favorite.'],
    ],
  },
  {
    title: 'Tikkas, Kebabs & Bites',
    items: [
      ['Paneer Tikka (Haryali / Achari / Malai)', 400, 'Grilled cottage cheese marinated in fresh herbs, tangy pickle spices, or rich cream, offering smoky and robust flavors.'],
      ["Kabab's (Green / Mushroom / Soya / Dahi)", '360–400', 'Green 360 | Mushroom 400 | Soya 380 | Dahi 360. Pan-seared or grilled patties blending aromatic spices with tender textures.'],
      ['Chilly Bites (Mushroom / Paneer / Potato)', '350–400', 'Mushroom 400 | Paneer 370 | Potato 350. Stir-fried bites tossed in vibrant Indo-Chinese sauce with bell peppers and onions.'],
      ['Spring Rolls', 320, 'Crispy pastry sheets wrapped around a savory, crunchy vegetable filling, served with a sweet dipping sauce.'],
    ],
  },
  {
    title: 'Noodles & Rice',
    items: [
      ['Manchurian (Dry / Gravy)', 280, 'Deep-fried vegetable dumplings tossed in a rich, dark soy-garlic sauce that is savory, tangy, and slightly spicy.'],
      ['Hakka Noodles', 300, 'Stir-fried long noodles tossed with crisp vegetables and soy sauce, offering a savory, aromatic, and classic flavor.'],
      ['Garlic Noodles', 300, 'Noodles tossed in a fragrant, heavy garlic-infused oil and soy blend, delivering a pungent, savory, and comforting taste.'],
      ['Veg Noodles', 250, 'Standard stir-fried noodles tossed with a colorful mix of julienned vegetables and light seasonings.'],
      ['Veg Fried Rice', 250, 'Wok-tossed aromatic rice mixed with diced vegetables and soy seasonings, offering a savory, fluffy, and mildly spiced profile.'],
    ],
  },
  {
    title: 'Pizzas',
    items: [
      ['Garlic Bread', 320, 'Crust brushed with aromatic garlic butter and herbs for a warm, savory crunch.'],
      ['Cheese Garlic Bread', 350, 'Garlic bread smothered in a thick layer of melted mozzarella and herbs.'],
      ['Margherita', 380, 'Classic pizza topped with rich tomato sauce, fresh mozzarella, and fragrant basil.'],
      ['Exotic Veg', 350, 'Loaded with bell peppers, olives, corn, and melted cheese for a fresh, crisp taste.'],
      ['Cheese-n-Corn', 350, 'Comforting pizza topped with sweet corn kernels and extra gooey melted cheese.'],
      ['Onion Capsicum', 300, 'Simple, classic pizza topped with crunchy onions, capsicum, and melted cheese.'],
      ['Paneer Exotic', 350, 'Layered with spiced cottage cheese cubes and colorful exotic vegetables.'],
    ],
  },
  {
    title: 'Pastas',
    items: [
      ['Creamy White Sauce', 350, 'Pasta tossed in a rich, velvety white cream sauce loaded with cheese and herbs.'],
      ['Alfredo', 350, 'Classic fettuccine or penne coated in a smooth, buttery parmesan and garlic cream sauce.'],
      ['Penne Arrabiata', 350, 'Pasta served in a fiery, garlic-infused spicy tomato sauce with fresh herbs.'],
      ['Pesto Spaghetti', 380, 'Spaghetti tossed in a vibrant, fragrant basil, pine nut, and parmesan pesto sauce.'],
      ['Aglio-e-Olio', 350, 'Simple Italian pasta tossed in extra virgin olive oil, sautéed garlic, chili flakes, and herbs.'],
      ['Creamy Spinach Ricotta', 380, 'Pasta enveloped in a rich, comforting sauce made with creamy spinach and soft ricotta cheese.'],
    ],
  },
  {
    title: 'South Indian',
    items: [
      ['Idli Sambhar', 150, 'Soft, steamed rice cakes served hot with a flavorful, spiced lentil soup and coconut chutney.'],
      ['Medu Vada', 150, 'Crispy, golden-fried savory lentil doughnuts with a fluffy interior, served with chutney and sambhar.'],
      ['Plain Dosa', 150, 'Thin, crispy fermented rice and lentil crepe served golden-brown with traditional accompaniments.'],
      ['Masala Dosa', 200, 'Crispy crepe folded over a savory, spiced potato mash filling, served with sambhar and chutneys.'],
      ['Fried Idli', 180, 'Steamed idli chunks tossed and pan-fried with aromatic spices, curry leaves, and mustard seeds for a crunchy twist.'],
    ],
  },
  {
    title: 'Rice & Biryani',
    items: [
      ['Steam Rice', 150],
      ['Jeera Rice', 200],
      ['Peas Pulao', 250],
      ['Schezwan Fried Rice', 280],
      ['Biryani Special', 280],
    ],
  },
  {
    title: 'Main Course Dal & Curries',
    items: [
      ['Dal Makhani', 300, 'Slow-cooked black lentils simmered in a rich, buttery, and creamy tomato gravy.'],
      ['Dal Tadka', 220, 'Yellow lentils finished with a sizzling tempering of ghee, garlic, cumin, and dried chillies.'],
      ['Dal Fry', 220, 'Thick, spiced yellow lentils cooked with onions, tomatoes, and aromatic herbs.'],
      ['Dal Panchrangi', 250, 'A wholesome blend of five different lentils cooked together with rustic spices.'],
      ['Dal Palak', 220, 'Nutritious lentils cooked and tempered together with fresh, blended spinach leaves.'],
    ],
  },
  {
    title: 'Paneer & Mushroom Specialties',
    items: [
      ['Shahi Paneer', 280, 'Cottage cheese cubes simmered in a rich, mildly sweet, and luxurious creamy cashew gravy.'],
      ['Palak Paneer', 250, 'Soft paneer cubes cooked in a smooth, vibrant, and spiced green spinach puree.'],
      ['Kadhai Paneer', 280, 'Paneer tossed with bell peppers and onions in a freshly ground, robust coriander-chili spice blend.'],
      ['Paneer Butter Masala', 280, 'Cottage cheese in a velvety, buttery, and slightly sweet tomato-onion sauce.'],
      ['Paneer Lababdar', 280, 'Paneer cooked in a rich, tangy, and intensely flavorful onion-tomato gravy with grated cheese.'],
      ['Cheese Butter Masala', 300, 'Cubes of cheese bathed in a rich, creamy, and buttery tomato gravy.'],
      ['Corn Capsicum', 250, 'Sweet corn kernels and crisp bell peppers tossed in a savory, spiced onion-tomato masala.'],
      ['Mushroom in Cream', 300, 'Tender mushrooms simmered in a rich, velvety, and delicately spiced white cream gravy.'],
      ['Mushroom Masala', 280, 'Mushrooms cooked in a thick, spicy, and aromatic onion-tomato masala.'],
      ['Kadhai Mushroom', 280, 'Mushrooms and bell peppers stir-fried in a heavy iron wok with coarse spices.'],
      ['Matar Mushroom', 280, 'A classic combination of tender mushrooms and green peas in a savory, spiced gravy.'],
    ],
  },
  {
    title: 'Vegetable & Special Mains',
    items: [
      ['Malai Kofta', 280, 'Deep-fried cottage cheese and vegetable dumplings served in a rich, creamy, and aromatic gravy.'],
      ['Rajma Masala', 250, 'Kidney beans simmered in a thick, savory, and homestyle onion-tomato gravy.'],
      ['Pindi Chole', 250, 'Spiced, dark chickpeas cooked with robust Punjabi spices and tangy pomegranate undertones.'],
      ['Navratan Korma', 300, 'A royal mixed vegetable and fruit curry cooked in a rich, creamy, and nutty sauce.'],
      ['Mix Veg.', 260, 'A colorful assortment of garden-fresh vegetables tossed in a savory, spiced onion-tomato masala.'],
      ['Kaju Curry', 350, 'Whole cashew nuts cooked in a rich, luxurious, and mildly spiced tomato-onion gravy.'],
      ['Aloo Gobi', 240, 'Classic dry-style preparation of potatoes and cauliflower florets tossed with turmeric and spices.'],
      ['Aloo Matar', 240, 'Comforting potatoes and green peas cooked in a spiced, runny tomato-onion gravy.'],
      ['Jeera Aloo', 220, 'Boiled potato cubes tossed simply in cumin seeds, ghee, and mild spices.'],
      ['Dum Aloo', 250, 'Baby potatoes slow-cooked in a rich, spiced, and deeply flavorful yogurt-based gravy.'],
      ['Aloo Bhindi', 250, 'Stir-fried okra and potatoes seasoned with basic Indian spices for a homestyle crunch.'],
      ['Bhindi Masala', 250, 'Fresh okra stir-fried with onions, tomatoes, and tangy spice powders.'],
      ['Gobi Matar', 220, 'Cauliflower and green peas sautéed together with onions, tomatoes, and ground spices.'],
      ['Baingan Masala', 220, 'Eggplant chunks cooked in a thick, pungent, and savory spiced tomato gravy.'],
      ['Richly Stuffed (Tomato / Aloo / Capsicum)', 300, 'Hollowed tomatoes, potatoes, or bell peppers packed with a savory filling and simmered in gravy.'],
      ['Gulab Jamun (Curry Style)', 280, 'Stuffed deep-fried khoya dumplings served in a rich, velvety, and mildly sweet aromatic tomato-cashew gravy.'],
      ['Rasmalai (Curry Style)', 280, 'Soft paneer and khoya discs bathed in a luxurious, creamy, and mildly spiced saffron-infused gravy.'],
    ],
  },
  {
    title: 'Rajasthani Specialities',
    items: [
      ['Mirchi-ka-Kutta', 280, 'A fiery and tangy coarse relish made of chopped green chilies, mustard seeds, and lemon juice.'],
      ['Lahsun-ki-Chutney', 250, 'A robust and spicy hot garlic paste tempered with chili, spices, and mustard oil.'],
      ['Raab (of choice)', 280, 'A traditional, nourishing, and warming rustic porridge made with flour, buttermilk, and spices.'],
      ['Ker Sangri', 300, 'An iconic desert delicacy made from wild desert berries and beans cooked in aromatic spices.'],
      ['Guar Phali', 250, 'Cluster beans sautéed and cooked with traditional Rajasthani spices and a touch of besan.'],
      ['Gatte ki Sabzi', 220, 'Soft spiced gram flour dumplings simmered in a tangy, yogurt-based gravy.'],
      ['Kadhi Pakoda', 220, 'Tangy and spiced gram flour and yogurt soup containing crispy fried onion dumplings.'],
      ['Chakki ki Sabzi', 250, 'Steamed wheat-gluten pieces cooked in a rich, spicy gravy.'],
      ['Rabori ki Sabzi', 280, 'Sun-dried corn and wheat papad dumplings cooked in a flavorful, spicy yogurt gravy.'],
      ['Papad Methi', 250, 'Crispy papad pieces and fresh fenugreek leaves cooked together in a savory, spiced yogurt sauce.'],
      ['Baadiye ki Sabzi', 300, 'Sundried-spiced lentil dumplings simmered in a rich, homestyle curry.'],
      ['Sev Tamatar', 250, 'Crunchy gram flour sev tossed in a spicy, tangy, and sweet tomato-onion gravy.'],
      ['Aakhe Aloo - Pyaaz', 300, 'Whole baby potatoes and small onions slow-cooked in a rich, spiced, and robust gravy.'],
      ['Kala Channe', 250, 'Black chickpeas simmered in a dark, aromatic, and spicy onion-tomato gravy.'],
      ['Kheech Galvani', 300, 'A traditional, slow-cooked coarse lentil and grain delicacy seasoned with rich spices.'],
      ['Malai Pyaaz', 250, 'Small onions cooked in a rich, mildly sweet, and luxurious creamy gravy.'],
      ['Methi Malai Matar', 300, 'Fresh fenugreek leaves and green peas simmered in a rich, sweet, and creamy white gravy.'],
    ],
  },
  {
    title: 'Breads',
    items: [
      ['Plain Phulka', 30],
      ['Butter Phulka', 35],
      ['Tandoori Roti', 35],
      ['Missi Roti', 80],
      ['Lachha Paratha', 80],
      ['Chilli Paratha', 80],
      ['Plain Naan', 100],
      ['Butter Naan', 100],
      ['Garlic Naan', 120],
      ['Cheese Naan', 150],
      ['Bajra ki Roti', 80],
      ['Makki ki Roti', 80],
      ['Rajwadi Khaand Paratha', 100],
    ],
  },
  {
    title: 'Desserts',
    items: [
      ['Golden Suji Halwa', 150],
      ['Sewaiyan Kheer', 250],
      ['Gajar ka Halwa', 250],
      ['Royal Gulab Jamun (2 Pieces)', 100],
      ['Jaggery Sheera', 150],
      ['Jaisalmeri Khaas Ghotua (2 Pieces)', 150],
      ['Mawa Kachori (2 Pieces)', 100],
      ['Artisan Ice-Cream Selection', 80],
      ['Pancakes (Honey / Nutella / Banana)', '250–350', 'Honey 250 | Nutella 350 | Banana 280'],
    ],
  },
];
